module.exports = __webpack_public_path__ + "static/media/ic-database-search.3fc22915.svg";